import { BaseActions } from '@/models/Common/Actions/BaseActions';
import { PolicyAPIClientRequestBuilder, PolicyAPIRequestBuilder } from '@/models/PolicyAPI/PolicyRequestBuilder';
import { IPolicyAPIRequestParams } from '@/models/PolicyAPI/interfaces/IPolicyAPIRequestParams';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { execAction } from '@/models/Common/Actions/handler';
import debug from 'debug';

const log = debug('sunny:PolicyAPIAction');

export class PolicyAPIActions extends BaseActions<PolicyAPIRequestBuilder | PolicyAPIClientRequestBuilder> {
  find(params: IPolicyAPIRequestParams): Promise<ResponseEither<string>> {
    log('Getting information of the policy api');
    return execAction('policyAPI', this.requestBuilder.createPolicyQuery(params));
  }
}
